import Vue from 'vue'
import Router from 'vue-router'

import Position from './views/Position'
import Thanks from './views/Thanks'

import Steps from './views/Steps'
import Personal from './views/Steps/1-Personal'
import Questionnaire from './views/Steps/2-Questionnaire'
import Experience from './views/Steps/3-Experience'
import Review from './views/Steps/4-Review'

Vue.use(Router)

const router = new Router({
	mode: 'history',

	base: process.env.BASE_URL,

	routes: [{
		path: '/position',
		name: 'position',
		component: Position,
		children: [{
			path: 'engineering-associate',
			name: 'engineering-associate',
			meta: {
				position: 'Engineering Associate'
			}
		}, {
			path: 'inside-sales-representative',
			name: 'inside-sales-representative',
			meta: {
				position: 'Inside Sales Representative'
			}
		}]
	}, {
		path: '/thanks',
		name: 'thanks',
		component: Thanks,
	}, {
		path: '*',
		component: Steps,
		children: [{
			path: '/personal',
			name: 'personal',
			component: Personal,
		}, {
			path: '/questionnaire',
			name: 'questionnaire',
			component: Questionnaire,
		}, {
			path: '/experience',
			name: 'experience',
			component: Experience,
		}, {
			path: '/review',
			name: 'review',
			component: Review,
		}],
	}],

	scrollBehavior() {
		return {
			x: 0,
			y: 0,
		}
	},
})

router.beforeEach((to, from, next) => {
	if (from.name === null) {
		if (to.name === undefined || to.name === null) {
			window.location = 'https://www.paceintl.com/careers/'
		} else {
			next()
		}
	} else {
		next()
	}
})

export default router
